import { get, post } from "../common/dataFetch";

export const getBorrowersData = (loanGuid: string) => {
    return get<any>(`BorrowerInformation/ReadAllByLoanGuidAsync?loanGuid=${loanGuid}`);
};

export const sendInviteMail = (data: any) => {
    return post<any>(`EmailNotification/SendAccountSetupInviteEmailToBorrower`, data);
};